import gql from 'graphql-tag';

const TOPIC_DELETE = gql`
mutation topicDelete ($id: ID!) {
  topicDelete (id: $id)
}
`;

export default TOPIC_DELETE;